.detailsContainer {
    display: flex;
}